import { useEffect, useState } from "react";
import { axiosInvoiceLess } from "../libs";

interface ICustomerValidation{
  internalId: string;
  //email: string;
  billTo :{
    address?: string;
    firstName?: string;
    lastName?: string;
    email: string;
    phone?: string;
  }
}

export const useValidateCustomer = () =>{
  const [isCustomer, setIsCustomer] = useState<Array<ICustomerValidation>>();

  useEffect(() => {
    async function CheckCustomers(){
      if(!isCustomer || isCustomer.length<=0){
          const customers = (await axiosInvoiceLess.get('/customers')).data
          const cus = customers?.docs as Array<any>;
          setIsCustomer(cus?.map((cs) => {
            return {
              internalId: cs._id,
              //email: cs.billTo?.email,
              billTo: cs?.billTo
            }
          }))
      }
    }
    CheckCustomers()
  }, [isCustomer]);


  return{
    isCustomer,
    setIsCustomer
  }
}